import constants from 'core/types'

const initialState = {
  pendingTransaction: null,
  latestReceipt: null,
  showStatus: false,
  statusMessage: '',
  transactionHash: '',
  blockNumber: null
}

export function transactionReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_PENDING_TRANSACTION:
      return Object.assign({}, state, {
        transactionLabel: action.payload.label,
        pendingTransaction: action.payload.transaction
      })

    case constants.TRANSACTION_MINED:
      return Object.assign({}, state, {
        transactionLabel: '',
        pendingTransaction: null,
        latestReceipt: action.payload.receipt
      })

    case constants.SET_TRANSACTION_STATUS:
      return Object.assign({}, state, {
        showStatus: action.payload.showStatus,
        statusMessage: action.payload.statusMessage,
        transactionHash: action.payload.transactionHash,
        blockNumber: action.payload.blockNumber
      })

    default:
      return state
  }
}
